import { useNavigationType, useLocation, useNavigate } from "react-router-dom";
import { resetConfig } from "../utilities/helper";
import PropTypes from "prop-types";
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";

const PolicyContext = createContext();

export function usePolicyContext() {
  return useContext(PolicyContext);
}

export function AddPolicyProvider(props) {
  const [showTermsConditionModal, setShowTermsConditionModal] = useState(false);
  const [showPrivacyNoticeModal, setShowPrivacyNoticeModal] = useState(false);
  const [showMemberConsentModal, setShowMemberConsentModal] = useState(false);
  const [personalMaxicareNumber, setPersonalMaxicareNumber] = useState("");
  const [memberConsentChecked, setMemberConsentChecked] = useState(false);
  const [initialAddPolicyData, setInitialAddPolicyData] = useState(null);
  const [isMiddleNameChecked, setIsMiddleNameChecked] = useState(false);
  const [showEditPolicyModal, setShowEditPolicyModal] = useState(false);
  const [showExpiredOtpModal, setShowExpiredOtpModal] = useState(false);
  const [configRestarted, setConfigRestarted] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [editAliasPolicy, setEditAliasPolicy] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState("");
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [displayAlert, setDisplayAlert] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [journeyStep, setJourneyStep] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [suffixName, setSuffixName] = useState("");
  const [birthDate, setBirthDate] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");

  const navigate = useNavigate();
  const navigationType = useNavigationType();

  function isPersonalValid() {
    return personalMaxicareNumber !== "" && birthDate !== null;
  }

  function isCorporateValid() {
    return companyCode !== "" && employeeNumber !== "" && birthDate !== null;
  }

  const location = useLocation();

  useEffect(() => {
    if (!isPersonalValid() && !isCorporateValid()) {
      if (location.pathname !== "/add-policy/choose-membership") {
        navigate("/add-policy", { replace: true });
      }
    }
  }, []);

  useEffect(() => {
    if (configRestarted) {
      resetConfig();
      setConfigRestarted(false);
    }
  }, [configRestarted]);

  const resetValues = () => {
    setPersonalMaxicareNumber("");
    setCompanyCode("");
    setEmployeeNumber("");
    setBirthDate(null);
    setOtp("");
  };

  const formatCompanyCode = (e) => {
    const inputVal = e.target.value.replace(/ /g, "");
    let inputNumbersOnly = inputVal.replace(/\D/g, "");

    setCompanyCode(inputNumbersOnly);
  };

  const formatMobileNumber = (e) => {
    const inputVal = e.target.value.replace(/ /g, "");
    let inputNumbersOnly = inputVal.replace(/\D/g, "");

    if (inputNumbersOnly.length > 10) {
      inputNumbersOnly = inputNumbersOnly.substr(0, 10);
    }

    setMobileNumber(inputNumbersOnly);
  };

  const formatEmployeeNumber = (e) => {
    const inputVal = e.target.value.replace(/ /g, "");
    let inputNumbersOnly = inputVal.replace(/\D/g, "");

    setEmployeeNumber(inputNumbersOnly);
  };

  const formatAndsetMaxicareCardNumber = (e) => {
    const input = e.target;
    const inputValue = input.value.replace(/\s/g, "");
    const numericValue = inputValue.replace(/\D/g, "");
    const selectionStart = input.selectionStart;
    const isDeleting = e.nativeEvent.inputType === "deleteContentBackward";

    if (/^\d*$/.test(inputValue) && numericValue.length <= 16) {
      const numberWithSpaces = numericValue.replace(/(\d{4})/g, "$1 ").trim();
      setPersonalMaxicareNumber(numberWithSpaces);

      let newCaretPosition = selectionStart;

      if (
        isDeleting &&
        selectionStart > 0 &&
        numberWithSpaces[selectionStart - 1] === " "
      ) {
        newCaretPosition--;
      }

      if (
        !isDeleting &&
        selectionStart > 0 &&
        numberWithSpaces[selectionStart - 1] === " "
      ) {
        newCaretPosition++;
      }

      setTimeout(() => {
        input.setSelectionRange(newCaretPosition, newCaretPosition);
      });
    }
  };
  const formatEditAliasPolicyValidation = (e) => {
    const inputValue = e.target.value;
    const regexPattern = /^[a-zA-ZñÑ\s-]+$/;

    if (inputValue === "" || regexPattern.test(inputValue)) {
      setEditAliasPolicy(inputValue);
    }
  };

  const handleBack = () => {
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
    setOtp("");
    navigate(-1);
  };

  const data = useMemo(
    () => ({
      formatEditAliasPolicyValidation,
      formatAndsetMaxicareCardNumber,
      setShowTermsConditionModal,
      setShowPrivacyNoticeModal,
      setShowMemberConsentModal,
      setPersonalMaxicareNumber,
      setMemberConsentChecked,
      setInitialAddPolicyData,
      setIsMiddleNameChecked,
      setShowExpiredOtpModal,
      setShowEditPolicyModal,
      formatEmployeeNumber,
      formatMobileNumber,
      setConfigRestarted,
      setEditAliasPolicy,
      setEmployeeNumber,
      formatCompanyCode,
      setSelectedPolicy,
      setShowErrorModal,
      isCorporateValid,
      isPersonalValid,
      setSelectedType,
      setTermsChecked,
      setMobileNumber,
      setAlertMessage,
      setDisplayAlert,
      setJourneyStep,
      setCompanyCode,
      setAlertTitle,
      setMiddleName,
      setSuffixName,
      setIsLoading,
      setFirstName,
      setBirthDate,
      setShowModal,
      setLastName,
      resetValues,
      handleBack,
      setEmail,
      navigate,
      setOtp,

      showTermsConditionModal,
      showPrivacyNoticeModal,
      showMemberConsentModal,
      personalMaxicareNumber,
      initialAddPolicyData,
      memberConsentChecked,
      showExpiredOtpModal,
      isMiddleNameChecked,
      showEditPolicyModal,
      editAliasPolicy,
      configRestarted,
      selectedPolicy,
      navigationType,
      employeeNumber,
      showErrorModal,
      selectedType,
      termsChecked,
      mobileNumber,
      alertMessage,
      displayAlert,
      journeyStep,
      companyCode,
      alertTitle,
      middleName,
      suffixName,
      isLoading,
      firstName,
      birthDate,
      showModal,
      lastName,
      email,
      otp,
    }),
    [
      isCorporateValid,
      isPersonalValid,

      showTermsConditionModal,
      showPrivacyNoticeModal,
      showMemberConsentModal,
      personalMaxicareNumber,
      initialAddPolicyData,
      memberConsentChecked,
      showExpiredOtpModal,
      isMiddleNameChecked,
      editAliasPolicy,
      configRestarted,
      navigationType,
      employeeNumber,
      selectedPolicy,
      showErrorModal,
      selectedType,
      termsChecked,
      mobileNumber,
      alertMessage,
      displayAlert,
      journeyStep,
      companyCode,
      alertTitle,
      middleName,
      suffixName,
      isLoading,
      firstName,
      birthDate,
      showModal,
      lastName,
      email,
      otp,
    ]
  );

  return (
    <PolicyContext.Provider value={data}>
      {props.children}
    </PolicyContext.Provider>
  );
}

AddPolicyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
